/*
 * File: d:\projects\AutoFiFront\src\Content\Home\ButtonFilter\ButtonFilter.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday March 2nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday March 2nd 2023 5:11:55 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { ReactNode, useEffect, useRef, useState } from 'react';
import CarService from 'Services/Cars/CarService';
import ProgressStepper from 'Content/Filters/ButtonFilter/ProgressBar/ProgressBar';
import StepElement from 'Content/Filters/ButtonFilter/StepElement/StepElement';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import styles from 'Content/Filters/ButtonFilter/ButtonFilter.module.css';

type ButtonFilterType ={
    setFilters: Function,
    curFilters: string[]
};

function ButtonFilter(props: ButtonFilterType){
    const [step, setStep] = useState(props.curFilters ? props.curFilters.length == 4 ? 3 : props.curFilters.length : 0);
    const [categorySelected, setCategorySelected]= useState(props.curFilters[0]);
    const [energySelected, setEnergySelected]= useState(props.curFilters[1]);
    const [brandSelected, setBrandSelected]= useState(props.curFilters[2]);
    const [modelSelected, setModelSelected]= useState(props.curFilters[3]);
    const [myReactNode, setMyReactNode] = useState<ReactNode>(<></>);
    const firstLoad = useRef(true);
    const themeColor = props.curFilters[0] == "CITYCAR" ? "var(--root-colors-second)" : props.curFilters[0]  == "SUV" ? "var(--root-colors-third)" : props.curFilters[0]  == "UTILITY" ? "var(--root-colors-fourth)" : props.curFilters[0]  == "SEDAN" ? "var(--root-colors-fifth)" : props.curFilters[0]  == "BREAK" ? "var(--root-colors-sixth)" : "var(--root-colors-first)";

    useEffect(()=> {
        if (firstLoad.current)
            firstLoad.current = false;
        else{
            const filters: string[] = [];

            if (categorySelected != "" && energySelected != undefined)
                filters.push(categorySelected);
            if (energySelected != "" && energySelected != undefined)
                filters.push(energySelected);
            if (brandSelected != "" && brandSelected != undefined)
                filters.push(brandSelected);
            if (modelSelected != "" && modelSelected != undefined)
                filters.push(modelSelected);
            props.setFilters(filters);
        }
    },[categorySelected, energySelected, brandSelected, modelSelected]);

    useEffect(() => {
        if (props.curFilters !== undefined && props.curFilters.length > 0)
            setStep(props.curFilters.length == 4 ? 3 : props.curFilters.length);
        else
            setStep(0);
    }, [props.curFilters]);

    const goToNextStep = (selected: string, setFunc: Function) => {
        setFunc(selected);
        if(step != 3)
            setStep(step + 1);
    };
    const backToPreviousStep = () =>{
        setStep(step-1);
    };

    useEffect(()=>{
        const filterSelected: string[]= [];
            switch (step) {
                case 0:
                    setBrandSelected("");
                    setModelSelected("");
                    setEnergySelected("");
                    setCategorySelected("");
                    var catInBack = CarService.getCarCategoriesAvailable();
                    catInBack.then(x => {x.sort(); setMyReactNode(<>{x.map((elem, index) => <StepElement key={elem + index} nextStep={goToNextStep} setNextFunction={setCategorySelected} elem={elem} trad={'carType'} isCat={true} themeColor={""}/>)}</>)});
                    break;
                case 1:
                    setBrandSelected("");
                    setModelSelected("");
                    setEnergySelected("");
                    filterSelected.push(categorySelected);
                    var energiesInBack = CarService.getCarEnergiesAvailable(filterSelected);
                    energiesInBack.then(x => {x.sort(); setMyReactNode(<>{x.map((elem, index) => <StepElement key={elem + index} nextStep={goToNextStep} setNextFunction={setEnergySelected} elem={elem} trad={'energyType'} isEnergy={true} themeColor={categorySelected}/>)}</>)});
                    break;
                case 2:
                    setBrandSelected("");
                    setModelSelected("");
                    filterSelected.push(categorySelected, energySelected);
                    var brandsInBack = CarService.getCarBrandsAvailable(filterSelected);
                    brandsInBack.then(x => {x.sort(); setMyReactNode(<>{x.map((elem, index) => <StepElement key={elem + index} nextStep={goToNextStep} setNextFunction={setBrandSelected} elem={elem} isBrand={true} themeColor={categorySelected}/>)}</>)});
                    break;
                case 3:
                    filterSelected.push(categorySelected, energySelected, brandSelected);
                    var modelsInBack = CarService.getCarModelsAvailable(filterSelected);
                    modelsInBack.then(x => {x.sort(); setMyReactNode(<>{x.map((elem, index) => <StepElement key={elem + index} nextStep={goToNextStep} setNextFunction={setModelSelected} elem={elem} themeColor={categorySelected}/>)}</>)});
                    break;
                default:
                    break;
            }
    },[step]);

    return (
        <React.Fragment>
            <div className={`${styles.stepperHolder}`}>
                {
                    step > 0 ? <div className={`${styles.stepperBtn}`}>
                                    <button type='submit'style={{color: themeColor}} className={`${styles.arrow}`} onClick={backToPreviousStep}><AiOutlineArrowLeft className={`${styles.iconArrow}`}/></button>
                                </div>
                                : null
                }
                <div className={`${styles.stepSelection}`}>
                    { myReactNode }
                </div>
                <div className={`${styles.stepperCta}`}>
                    <ProgressStepper bgColor={"var(--theme-bg-color)"} barColor={categorySelected} step={4} curStep={step}/>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ButtonFilter;
